module.exports = __webpack_public_path__ + "static/media/nightlyfe.fa20c0fd.png";